module.exports = __webpack_public_path__ + "img/chevron-left.5fbe3c94.svg";